import { Component, Input } from '@angular/core';

@Component({
    selector: 'rmis-status',
    templateUrl: './rmis-status.component.html',
    standalone: false
})
export class RMISStatus {
    @Input() rmisStatusColor: string = "light";
    @Input() rmisStatusTextColor: string = "dark";
    @Input() rmisStatusAbbrev: string = "";
    @Input() rmisStatusTooltip: string = "";

    constructor() {
    }

    //ngOnChanges() {
    //    this.getBadgeColor();
    //    this.getRMISStatusFirstLetter();
    //    console.log("ngOnChanges", this.carrierList);
    //}

    //private getBadgeColor() {
    //    this.rmisBadgeColor = this.carrierList.rmisCertifiedColor;
    //    //console.log("getBadgeColor", this.rmisBadgeColor);
    //}

    //public getRMISStatusFirstLetter() {
    //    var firstLetter: string = "\u00A0";
    //    if (this.carrierList.rmisStatus != null && this.carrierList.rmisStatus.length > 0) {
    //        firstLetter = this.carrierList.rmisStatus.charAt(0);
    //    }
    //    this.rmisFirstLetter = firstLetter;
    //    //console.log("getRMISStatusFirstLetter", this.rmisFirstLetter);
    //}
}
